type CounterSignatureRequestRecipient = {
    userEmailAddress: string;
    userId: string | undefined;
    companyId: string;
    companyName: string;
    companyDepartmentName: string;
    companyDepartmentId: number | undefined;
};

export default CounterSignatureRequestRecipient;

export function CounterSignatureRequestRecipient_toString(recipient: CounterSignatureRequestRecipient): string {
    const string =
        recipient.companyDepartmentId
            ? `${recipient.companyName}, ${recipient.companyDepartmentName}`
            : recipient.companyId
            ? recipient.companyName
            : recipient.userEmailAddress;

        return string;
}
